import Footer from "@scenes/pdp/utils/Footer";
import { Diamond } from "@src/types/DiamondDetail";
import { useEffect, useState } from "react";
import { Platform } from "react-native";
import styled from "styled-components/native";
import ImageGallery from "../GalleryView";
import { GalleryCategory } from "../GalleryView/utils/GalleryType";
import { ImageObject } from "../GalleryView/utils/types";
import GalleryViewMatch from "../GalleryViewMatch/GalleryViewMatch";
import MatchStoneGalleryModel from "../MatchStoneGalleryModel/MatchStoneGalleryModel";
import { useFindMatch } from "@scenes/findMatch/FindMatchContext";
import { css } from "styled-components/native";

type GalleryViewModalProps = {
  isOpen?: boolean;
  onClose?: () => void;
  ReceivedMedia: any;
  OtherMedia: any;
  initialIndex?: number;
  image_thumb_url?: string;
  handleOpenShareModel?: any;
  applyRadius?: boolean;
  productType?: string;
  itemDetail?: Diamond;
  resizeImage?: boolean;
  extraSmallImage?: boolean;
  ceterIconTheme?: string;
  isPrimary?: boolean;
  containerWidth: number;
  testIDPrefix?: string;
};

const GalleryWithCounterView = ({
  ReceivedMedia,
  OtherMedia,
  image_thumb_url,
  itemDetail,
  extraSmallImage = false,
  ceterIconTheme = "",
  isPrimary = false,
  containerWidth,
  testIDPrefix = "pdp.gallery",
}: GalleryViewModalProps) => {
  const { theme, productType } = useFindMatch();
  const [leftCurrentIndex, setLeftCurrentIndex] = useState(0);

  const [showGalleryModal, setshowGalleryModal] = useState(false);

  useEffect(() => {
    if (Platform.OS === "web") {
      setLeftCurrentIndex(0);
    }
  }, [itemDetail]);

  const leftItemLeftClickEvent = () => {
    if (leftCurrentIndex !== 0) {
      setLeftCurrentIndex(leftCurrentIndex - 1);
    }
  };

  const leftItemRightClickEvent = () => {
    if (leftCurrentIndex < ReceivedMedia?.length - 1) {
      setLeftCurrentIndex(leftCurrentIndex + 1);
    }
  };

  const leftFooterComponent = (image: ImageObject, currentIndex: number) => {
    return (
      <Footer
        hasArrow={Platform.OS === "web" && !theme.isMobile}
        leftClickEvent={leftItemLeftClickEvent}
        rightClickEvent={leftItemRightClickEvent}
        total={ReceivedMedia?.length}
        centerString={"of"}
        currentIndex={currentIndex}
        ceterIconTheme={ceterIconTheme}
      />
    );
  };

  const handleOpenExpandModel = () => {
    setshowGalleryModal(true);
  };
  return (
    <Container>
      {theme.isMobile ? (
        <ImageContainer height={containerWidth}>
          <GalleryViewMatch
            ReceivedMedia={ReceivedMedia}
            initialIndex={0}
            image_thumb_url={image_thumb_url}
            productType={productType}
            itemDetail={itemDetail}
            handleOpenExpandModel={handleOpenExpandModel}
            imageWidth={containerWidth}
            testIDPrefix={testIDPrefix}
          />
        </ImageContainer>
      ) : (
        <ImageGallery
          images={ReceivedMedia}
          resizeMode="cover"
          initialIndex={leftCurrentIndex}
          renderFooterComponent={leftFooterComponent}
          thumbColor={theme["core-06"]}
          isOpen={Platform.OS === "web" && !theme.isMobile}
          isExternalView={GalleryCategory.productDetail}
          thumbDefaultBorderColor={theme["core-03"]}
          image_thumb_url={itemDetail?.image_thumb_url}
          productType={productType}
          itemDetail={itemDetail}
          isClickable={true}
          handleOpenExpandModel={handleOpenExpandModel}
          extraSmallImage={extraSmallImage}
          isSmallDeviceWidth={!theme.isMobile ? true : false}
          imageWidth={containerWidth}
          resizeImage={theme.isMobile ? false : true}
          isMatchModel={true}
          showExpand={true}
          applyRadius={theme.isLargeScreen}
          fromReviewPage={false}
          testIDPrefix={testIDPrefix}
        />
      )}

      {showGalleryModal && (
        <MatchStoneGalleryModel
          onClose={() => setshowGalleryModal(false)}
          isOpen={showGalleryModal}
          ReceivedMedia={ReceivedMedia}
          OtherMedia={OtherMedia}
          image_thumb_url={image_thumb_url}
          productType={productType as string}
          itemDetail={itemDetail}
          isPrimary={isPrimary}
        />
      )}
    </Container>
  );
};

const Container = styled.View``;

const ImageContainer = styled.View<{ height: number }>`
  ${({ theme }) =>
    Platform.OS !== "web" &&
    theme.isMobile &&
    css`
      flex: 1;
      height: 100%;
    `}
  width: ${({ height }) => height}px;
`;

export default GalleryWithCounterView;
